import { Box, Flex } from "@mantine/core";
import { useEffect } from "react";

interface IEditorModalProps {
  link: string;
}

const EditorModal = ({ link }: IEditorModalProps) => {
  return (
    <Flex direction={"column"}>
      <Box bg={"white"} w={"100%"} h={"70vh"}>
        <iframe
          //title="sign-now editor"
          src={link}
          height="100%"
          width="100%"
          style={{ minHeight: "40vh" }}
        ></iframe>
      </Box>
    </Flex>
  );
};

export default EditorModal;
